<div class="pt-3">
    EstiMate has classified your project description into <strong>possible
        project
        types</strong>. In case EstiMate found a good fit the recommendation
    will be
    highlighted with *.
    <br>
    <strong>Please select a type to continue or re-estimate.</strong>
    <mat-grid-list cols="2" rowHeight="2:1">
        <ng-container *ngFor="let classification of projectClassification$ | async">
            <mat-grid-tile>
                <button [ngClass]="{
                    'greenbtn': (selectedProjectType$ | async) === classification, 
                    'bluebtn': classification.includes('*') && (selectedProjectType$ | async) !== classification,
                    'blackbtn': !classification.includes('*') && (selectedProjectType$ | async) !== classification}"
                    class=" btn input-element button-bottom w-75" (click)="selectProjectType(classification, true)">
                    {{ classification }}
                </button>
            </mat-grid-tile>
        </ng-container>
    </mat-grid-list>
</div>
<div class="d-flex align-items-center mt-3 mb-3">
    <div class="d-flex align-items-center mr-2">
        <div class="circle-legend blue-circle"></div>
        <span class="legend-text ml-2">Recommendation</span>
    </div>
    <div class="d-flex align-items-center mr-2">
        <div class="circle-legend green-second-circle"></div>
        <span class="legend-text ml-2">Selection</span>
    </div>
</div>